import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSingleQuizathonStart } from "../../redux/quizathon/reducer";
import { selectIsLoadingSingleQuizathon, selectSingleQuizathon } from "../../redux/quizathon/selectors";

const useSingleQuizathonGet = ({ id }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoadingSingleQuizathon);
  const singleQuizathon = useSelector(selectSingleQuizathon);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);

  const getSingleQuizathon = useCallback(() => {
    if (!id) return;
    dispatch(getSingleQuizathonStart(id));
  }, [dispatch, id]);

 

  useEffect(() => {
    if (!id) return;
    getSingleQuizathon();
  }, [id, getSingleQuizathon, fetch]);

  return {
    singleQuizathon,
    loadingSingleQuizathon: isLoading,
    refetch,
  };
};

export default useSingleQuizathonGet;
